import api from "api/api"

export const GET_PRODUCT_LOCATIONS = '[PRODUCT_LOCATIONS] GET_PRODUCT_LOCATIONS'
export const TOGGLE_PRODUCT_LOCATION = '[PRODUCT_LOCATIONS] TOGGLE_PRODUCT_LOCATION'

export function getProductLocations(productId) {
  return async (dispatch) => {
    try {
      const response = await api.get(`/product-locations/${productId}`)
      dispatch({
        type: GET_PRODUCT_LOCATIONS,
        payload: response.data.data
      })
    } catch (error) {
      console.error(GET_PRODUCT_LOCATIONS, error)
    }
  }
}

export function toggleProductLocation(productId, locationId) {
  return async (dispatch) => {
    dispatch({
      type: TOGGLE_PRODUCT_LOCATION,
      payload: { locationId }
    })

    try {
      await api.post('/product-location/toggle', { producto_id: productId, ubicacion_almacen_id: locationId })
    } catch (error) {
      console.error(TOGGLE_PRODUCT_LOCATION, error)
    }
  }
}
